import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const parseParams = () => {
  // Check hash first (Implicit grant - tokens come in URL fragment)
  const hash = window.location.hash;
  console.log("[OAuth] Full URL:", window.location.href);
  console.log("[OAuth] Hash:", hash);
  
  if (hash) {
    const hashParams = new URLSearchParams(hash.replace(/^#/, ""));
    const accessToken = hashParams.get("access_token");
    const idToken = hashParams.get("id_token");
    const error = hashParams.get("error");
    const errorDescription = hashParams.get("error_description");
    
    console.log("[OAuth] Parsed from hash - accessToken:", accessToken ? "present" : "missing");
    console.log("[OAuth] Parsed from hash - idToken:", idToken ? "present" : "missing");
    console.log("[OAuth] Parsed from hash - error:", error);
    
    if (accessToken || error) {
      return { accessToken, idToken, error, errorDescription };
    }
  }

  // Check query params (Authorization code grant fallback)
  const searchParams = new URLSearchParams(window.location.search);
  return {
    accessToken: searchParams.get("access_token"),
    idToken: searchParams.get("id_token"),
    error: searchParams.get("error"),
    errorDescription: searchParams.get("error_description"),
  };
};

const OAuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const { completeExternalLogin, user } = useAuth();
  const [message, setMessage] = useState("Completing sign-in...");
  const processedRef = useRef(false);

  useEffect(() => {
    // Prevent double processing (React StrictMode can run effects twice)
    if (processedRef.current) {
      console.log("[OAuth] Already processed, skipping");
      return;
    }
    processedRef.current = true;

    const { accessToken, idToken, error, errorDescription } = parseParams();

    const finish = async () => {
      if (error) {
        const errorMsg = errorDescription || error;
        console.error("[OAuth] Error from provider:", errorMsg);
        setMessage(`Sign-in failed: ${errorMsg}. Please try again.`);
        return;
      }
      
      if (!accessToken) {
        if (user) {
          console.log("[OAuth] User already authenticated, redirecting to dashboard");
          navigate("/dashboard", { replace: true });
          return;
        }
        console.error("[OAuth] No access token found in URL");
        setMessage("Missing access token. Please try signing in again.");
        return;
      }
      
      try {
        setMessage("Processing secure sign-in...");
        console.log("[OAuth] Calling completeExternalLogin...");
        await completeExternalLogin(accessToken, idToken);
        console.log("[OAuth] Login complete, navigating to dashboard");
        
        // Success!
        setMessage("Sign-in successful! Redirecting...");
        // Clear the hash to prevent re-processing on refresh
        window.history.replaceState(null, "", window.location.pathname);
        setTimeout(() => navigate("/dashboard", { replace: true }), 1000);
      } catch (err) {
        const errorMsg = err instanceof Error ? err.message : "Unknown error";
        console.error("[OAuth] completeExternalLogin failed:", errorMsg);
        setMessage(`Sign-in failed: ${errorMsg}. Please try again.`);
      }
    };

    finish();
  }, [completeExternalLogin, navigate]);

  return (
    <div style={{ padding: 24, textAlign: "center", maxWidth: 600, margin: "0 auto" }}>
      <h2>Google Sign-In</h2>
      <p style={{ fontSize: 18, margin: "20px 0" }}>{message}</p>
      
      <div style={{ marginTop: 20, padding: 10, background: "#f5f5f5", borderRadius: 8, fontSize: 12, textAlign: "left", fontFamily: "monospace" }}>
         <p><strong>Debug Info:</strong></p>
         <p>URL: {window.location.href}</p>
         <p>Hash present: {window.location.hash ? "Yes" : "No"}</p>
      </div>

      {message.includes("failed") && (
        <button 
          onClick={() => navigate("/login")}
          style={{ marginTop: 20, padding: "8px 16px", cursor: "pointer" }}
        >
          Back to Login
        </button>
      )}
    </div>
  );
};

export default OAuthCallbackPage;

